module.exports = __webpack_public_path__ + "img/download (1).f7ea03e4.svg";